export const GENERAL_QUESTIONS = [
  'How can I make my home more energy efficient?',
  'What home maintenance tasks do people often forget?',
  'How do I repair a leaky faucet?',
  'What’s the best way to declutter my garage?',
  'Which tools are essential for new homeowners?',
  'How often should I change air filters?',
  'What’s the best way to improve indoor air quality?',
  'How can I extend the lifespan of my batteries?',
  'How do I seal drafty doors and windows?',
  'How do I choose a flooring color?',
  'What are the best types of flooring for the price?',
  'What are some storage solutions for small bathrooms?',
  'What are some cleaners with natural ingredients?',
  'How can I make my kitchen more functional?',
  'What are some paint colors you can’t go wrong with?',
  'Can I have paint shipped to my house?',
  'How can I brighten a dark room?',
  'What’s a good grill for beginners?',
  'What trees are trending this year?',
  'What pre-lit trees look the most realistic?',
  'How do I decide between a real or artificial Christmas tree?',
  'What are some holiday hosting must-haves?',
  'What ornaments and colors are popular this year?',
  'What are the highest-rated ladders in stock?',
  'Which extension cords are safe for outdoor lights?',
  'What do I need to hang holiday lights?',
  'Do smart thermostats lower costs?',
  'How do I protect plants over winter?',
  'What are the best ways to clear snow and ice?',
  'How can I better insulate my garage?',
  'How do I protect pipes and faucets from freezing?',
  'How do I winterize power equipment?',
  'How can I prep my house for winter?',
  'How do I prep for winter emergencies?',
  'What are the best deals on power tool packages?',
  'What are the best window coverings for retaining heat?',
];

export const PIP_QUESTIONS = [
  'What is the warranty on this item?',
  'What are the delivery options for this item?',
  'What do I need to know before using it?',
  'What do I need to know before I buy?',
  'What are the key features?',
  'What are the top uses for this product?',
  'Can this item be returned or exchanged?',
  'What are the key specifications?',
  'How soon can I get this delivered to my zip code?',
  'What is the delivery charge for this item?',
];
